import { ChevronDownIcon } from "@/components/ui/icon";
import { Select, SelectTrigger, SelectInput, SelectIcon, SelectPortal, SelectContent, SelectItem } from "@/components/ui/select";
import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import React from 'react';

export default function SelectableElement({ header, mainText, selections, selected, setSelected, disabled }) {
    console.log(selections, selected)
    return (
        <>
            {header && <Text className="text-2xl mb-2 mt-1 leading-2xl text-secondary-900">{header}</Text>}
            <HStack className="justify-between items-center px-3 mb-2">
                <Text className="text-xl leading-2xl text-secondary-900">
                    {mainText}
                </Text>
                <Select accessibilityLabel={header} variant="outline" size="md" onValueChange={itemValue => setSelected(itemValue)} className="w-[120px] bg-secondary-50 border rounded-md text-secondary-900">
                        <SelectTrigger>
                            <SelectInput placeholder={selections[0]} value={selections[selected]} />
                            <SelectIcon className="absolute right-3 text-secondary-900" as={ChevronDownIcon} />
                        </SelectTrigger>
                        <SelectPortal>
                            <SelectContent>
                                {selections.map((item, idx) => <SelectItem key={'S' + idx} label={item} value={idx} />)}
                            </SelectContent>
                        </SelectPortal>
                    </Select>
            </HStack>
        </>
    );
}